import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '../../../environments/environment';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class ManufacturerService {
  private apiUrl = environment.apiUrl + '/manufacturers';

  constructor(private http: HttpClient) {
    console.log(
      'Application Environment:',
      environment.production ? 'Production' : 'Development'
    );
    console.log('API URL:', this.apiUrl);
  }

  // Create new manufacturer
  addManufacturer(manufacturerData: any) {
    return this.http.post(this.apiUrl, manufacturerData);
  }

  // Get list of manufacturers with optional filters
  getManufacturers(params?: any) {
    return this.http.get(this.apiUrl, { params });
  }

  // manufacturers.service.ts

  searchManufacturersByName(name: string) {
    return this.http.get(`${this.apiUrl}/search`, {
      params: { name },
    });
  }

  // Get manufacturer by ID
  getManufacturerById(id: string) {
    return this.http.get(`${this.apiUrl}/${id}`);
  }

  getAllManufacturersBrands() {
    return this.http.get(`${this.apiUrl}/brands/all`);
  }

  // Update manufacturer by ID
  updateManufacturer(id: string, manufacturerData: any) {
    return this.http.put(`${this.apiUrl}/${id}`, manufacturerData);
  }

  // Soft delete manufacturer by ID
  deleteManufacturer(id: string) {
    return this.http.delete(`${this.apiUrl}/${id}`);
  }

  // Download manufacturer template (Creation)
  downloadTemplate(): Observable<Blob> {
    return this.http.get(`${this.apiUrl}/template`, {
      responseType: 'blob',
    });
  }

  // Download Brands & Contacts template (Brands/Contacts)
  downloadBrandsContactsTemplate(): Observable<Blob> {
    return this.http.get(`${this.apiUrl}/template/brands-contacts`, {
      responseType: 'blob',
    });
  }

  // Bulk upload manufacturers (Creation)
  bulkUpload(formData: FormData): Observable<any> {
    return this.http.post(`${this.apiUrl}/upload`, formData);
  }

  // Bulk upload Brands & Contacts (Brands/Contacts)
  bulkBrandsContactsUpload(formData: FormData): Observable<any> {
    return this.http.post(`${this.apiUrl}/upload/brands-contacts`, formData);
  }

  // Export manufacturers to Excel
  exportManufacturers(): Observable<Blob> {
    return this.http.get(`${this.apiUrl}/export/excel`, {
      responseType: 'blob',
    });
  }
}
